var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApi = function SvgApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18h1.896l.544-2.421h2.637L7.619 18h2.179L6.97 7H4.792L2 18Zm4.7-4.105-.736-3.286a11.601 11.601 0 0 1-.096-.654c-.028-.26-.053-.464-.076-.61h-.041c-.023.146-.05.35-.083.61a6.26 6.26 0 0 1-.11.654l-.74 3.286H6.7ZM11.362 18h2.062v-3.85h1.206c1.025 0 1.809-.298 2.351-.894.547-.597.82-1.487.82-2.67 0-1.182-.273-2.067-.82-2.654-.542-.586-1.323-.88-2.344-.88h-3.275V18Zm2.062-5.541V8.752h1.013c.478 0 .816.16 1.014.481.202.316.303.77.303 1.361 0 .597-.101 1.058-.303 1.383-.198.321-.536.482-1.014.482h-1.013Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18h-2.055V7.053H22V18Z",
    fill: "#323232"
  })));
};
export default SvgApi;